module.exports = __webpack_public_path__ + "img/howitworkszoom.d43d49b1.svg";